import React from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import PageShell from "@/components/pages/PageShell";
import HeroSoon from "@/components/landing/HeroSoon";
import { LaunchStrip, PartnerBand } from "@/components/landing/PartnerBits";
import { SectionHead } from "@/components/landing/Section";
import { SOON_TRAILS } from "@/config/trails";

const OtherTrails = ({ current }) => {
  const { t } = useLang();
  const tr = t.trails;
  return (
    <section data-testid="other-trails">
      <SectionHead kicker={tr.comingSoon} title={tr.otherTrails} />
      <div className="mt-10 grid sm:grid-cols-3 gap-6">
        {SOON_TRAILS.filter((s) => s.key !== current).map((s) => (
          <Link key={s.key} to={`/trails/${s.key}`} data-testid={`other-trail-${s.key}`} className="group journal-card overflow-hidden hover:shadow-journal-lg transition-shadow">
            <img src={s.img} alt={tr.names[s.key]} loading="lazy" className="w-full h-44 object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
            <div className="p-5">
              <div className="text-xs font-extrabold uppercase tracking-[0.14em] text-amber-dark">{tr.slides[s.key].kicker}</div>
              <div className="mt-1 font-display text-xl font-semibold text-ink inline-flex items-center gap-2">
                {tr.names[s.key]} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default function TrailPage() {
  const { key } = useParams();
  const navigate = useNavigate();
  const slide = SOON_TRAILS.find((s) => s.key === key);
  if (!slide) return <Navigate to="/" replace />;
  return (
    <PageShell testId={`trail-page-${key}`}>
      <div className="space-y-20 md:space-y-28">
        <HeroSoon slide={slide} onPlayNow={() => navigate("/")} onPage />
        <LaunchStrip testId="trail-launch-strip" />
        <PartnerBand testId="trail-partner-band" />
        <OtherTrails current={key} />
      </div>
    </PageShell>
  );
}
